<div class="modal-header">
  <h4 class="modal-title">{{ 'createEventModal.title' | translate }}</h4>
  <button type="button" class="btn-close" (click)="cancel()"></button>
</div>
<div class="modal-body">
  <p class="text-muted mb-5">{{ 'createEventModal.description' | translate }}</p>

  @if (loading) {
    <div class="text-center py-10">
      <i class="fa fa-spinner fa-spin fs-3 text-muted"></i>
      <p class="text-muted mt-3">{{ 'createEventModal.loading' | translate }}</p>
    </div>
  } @else if (companies.length === 0) {
    <div class="text-center py-10">
      <i class="fa fa-building fs-3x text-muted mb-5"></i>
      <h5 class="text-muted">{{ 'createEventModal.noOrganisations' | translate }}</h5>
    </div>
  } @else {
    <div class="d-flex flex-column gap-3">
      @for (company of companies; track company.company_id) {
        <div
          class="card cursor-pointer border-2 hover-elevate-up mb-0"
          (click)="selectCompany(company)"
        >
          <div class="card-body d-flex align-items-center p-4">
            @if (company.company_logo_url) {
              <img
                [src]="company.company_logo_url"
                class="rounded me-4"
                style="width: 40px; height: 40px; object-fit: cover;"
                alt=""
              />
            } @else {
              <div
                class="rounded bg-light d-flex align-items-center justify-content-center me-4"
                style="width: 40px; height: 40px;"
              >
                <i class="fa" [class.fa-user]="company.is_personal" [class.fa-building]="!company.is_personal" [class.text-primary]="!company.is_personal" [class.text-muted]="company.is_personal"></i>
              </div>
            }
            <div class="flex-grow-1">
              <div class="fw-bold">{{ company.company_name }}</div>
              @if (company.is_personal) {
                <span class="badge badge-light-secondary fs-9">{{ 'createEventModal.personal' | translate }}</span>
              } @else if (company.company_type) {
                <span class="text-muted fs-8">{{ company.company_type }}</span>
              }
            </div>
            <i class="fa fa-chevron-right text-muted"></i>
          </div>
        </div>
      }
    </div>
  }
</div>
